import React, { useEffect, useState } from "react";
import { Flex, Form } from "styles/global-style";
import Modal from "components/Modal";
import Input from "components/Input";
import Button from "components/Button";

export default function AddPersonPopup({ showAddPerson, closeAddPerson, addPersonDate, list, submitAddTimeline }) {
  const [inputValid, setInputValid] = useState(false);
  const [people, setTimeline] = useState([{ firstname: "", lastname: "", email: "", id: null }]); // Initialize with one person including id

  // Update the person's firstname, lastname, email, or id based on index and field type
  const updatePerson = (index, field, value) => {
    let updatedTimeline = [...people];
    updatedTimeline[index][field] = value;

    if ((field === "firstname" || field === "lastname") && people[index].id && people[index].id > -1) {
      updatedTimeline[index].id = null;
    }

    // Make sure there's always one empty row available
    const hasEmptySlot = updatedTimeline.some((person) => !person.firstname.trim() && !person.lastname.trim());
    if (!hasEmptySlot) updatedTimeline = [...updatedTimeline, { firstname: "", lastname: "", email: "", id: null }];

    setTimeline(updatedTimeline);
    // Validate inputs: at least one name field must be filled
    const allValid = updatedTimeline.some((person) => person.firstname.trim() || person.lastname.trim());
    setInputValid(allValid);
  };


  // Handle form submission
  const handleSubmit = (e) => {
    if (e) e.preventDefault();
    const validTimeline = people.filter((person) => person.firstname.trim() || person.lastname.trim()); // Filter out empty names
    submitAddTimeline(validTimeline, addPersonDate); // Pass valid people to the submit handler with ids
  };

  useEffect(() => {
    if (!showAddPerson) {
      setInputValid(false);
      setTimeline([{ firstname: "", lastname: "", email: "", id: null }]);
    }
  }, [showAddPerson]);

  return (
    showAddPerson && (
      <Modal title={"Add person to project"} closeCb={closeAddPerson}>
        <Form onSubmit={handleSubmit} gap={8}>
          <div style={{ color: "#00000088" }}>
            You can just add them now, and email invite later.
            <br />
            Joining on {addPersonDate?.getISODate()}.
          </div>

          {people.map((person, index) => (
            <Flex key={index}>
              <Input
                caption="First name"
                placeholder="First name..."
                value={person.firstname}
                onChange={(e) => updatePerson(index, "firstname", e.target.value)}
                autoFocus={index === 0}
                nocaption={index > 0}
                left
              />
              <Input
                caption="Last name"
                placeholder="Last name..."
                value={person.lastname}
                onChange={(e) => updatePerson(index, "lastname", e.target.value)}
                nocaption={index > 0}
                left
              />
              <Input
                caption="Email (optional)"
                placeholder="email@here"
                value={person.email}
                onChange={(e) => updatePerson(index, "email", e.target.value)}
                nocaption={index > 0}
                left
              />
            </Flex>
          ))}
          <br />
          <Button text="Add them" callback={handleSubmit} large color="purple" disabled={!inputValid} />
        </Form>
      </Modal>
    )
  );
}
